// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".JKkCAHIftGjqZB {\n  padding: 0;\n  margin-bottom: 0;\n  background: transparent;\n}\n.JKkCAHIftGjqZB:hover,\n.JKkCAHIftGjqZB:focus,\n.JKkCAHIftGjqZB:active {\n  background: transparent;\n}\n.JKkCAHIftGjqZB:hover svg,\n.JKkCAHIftGjqZB:focus svg,\n.JKkCAHIftGjqZB:active svg {\n  transform: scale(1.2);\n  transition-duration: 85ms;\n  transition-property: transform;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": "JKkCAHIftGjqZB"
};
export default ___CSS_LOADER_EXPORT___;
